import { AssettrakAccess, Vehicle } from 'server'

export const canSeeVehicleLocationHistory = (assettrakAccess?: AssettrakAccess, vehicle?: Vehicle) => {
  if (!assettrakAccess || !vehicle) return false
  const systemAdmin = assettrakAccess?.system_admin
  const agencyAdmin = assettrakAccess?.agency_admin
  const agencyId = assettrakAccess?.agency

  return systemAdmin || (agencyAdmin && agencyId === vehicle.agency_id)
}

export const canEditAgency = (assettrakAccess: AssettrakAccess, vehicle: Vehicle) => {
  const userAgency = assettrakAccess?.agency
  const agencyAdmin = assettrakAccess?.agency_admin
  const systemAdmin = assettrakAccess?.system_admin
  const isAgency = userAgency === vehicle.agency_id

  let editOwnAgency = isAgency && agencyAdmin
  if (systemAdmin) return true
  return editOwnAgency
}
